import React from 'react';
import { MediaSlot } from './MediaSlot';
import type { BundleItem } from '../../types/artTherapy';
type BundleCardProps = {
  item: BundleItem;
  image: string;
  slot: string;
  featured?: boolean;
};
export function BundleCard({
  item,
  image,
  slot,
  featured = false
}: BundleCardProps) {
  return <article className={`flex flex-col overflow-hidden rounded-3xl bg-white ${featured ? 'border-2 border-[#E2C845]' : 'border border-[#F3E7E1]'}`} data-id="element-37" data-mp="1efp6vvp0ni08">
      <div className="px-[17%] pb-4 pt-4" data-id="element-38" data-mp="lqhze77l3i2u">
        <MediaSlot src={image} slot={slot} alt={item.title} aspect={featured ? 'aspect-square' : 'aspect-[5/6]'} className="rounded-2xl shadow-[0_10px_24px_-14px_rgba(74,58,53,0.5)]" data-id="element-39" data-mp="lrjk73eejixr" />
      </div>
      <div className={`flex flex-1 flex-col border-t border-dashed border-lavender-line px-5 pb-6 pt-4 ${featured ? 'items-center text-center' : ''}`} data-id="element-40" data-mp="3u6bh2pdnizlh">
        <span className={`w-fit rounded-full px-4 py-1.5 text-[13px] font-extrabold uppercase tracking-[0.06em] ${featured ? 'bg-[#FBE87A] text-ink' : 'border border-gold-line bg-gold-soft text-gold-deep'}`} data-id="element-41" data-mp="2ypg54ibhb8b">
          {item.badge}
        </span>
        <h3 className="mt-3 text-lg font-bold leading-snug text-ink" data-id="element-42" data-mp="2numikno49wjf">{item.title}</h3>
        {item.value && <p className="mt-2 flex flex-wrap items-center gap-2 text-[15px] text-body" data-id="element-43" data-mp="2iw1pr9b72f50">
            <span data-id="element-44" data-mp="2evr9n3tou8cf">
              Értéke: <span className="font-bold text-body/80 line-through" data-id="element-45" data-mp="2eswotb6rilih">{item.value}</span> —
            </span>
            <span className="rounded-full border border-gold-line bg-gold-soft px-3.5 py-1 text-[14px] font-extrabold uppercase text-gold" data-id="element-46" data-mp="29xzfe35kma52">
              ma ingyen
            </span>
          </p>}
        <p className="mt-2 text-[16px] leading-relaxed text-body" data-id="element-47" data-mp="2003avu752dfx">{item.description}</p>
      </div>
    </article>;
}